<template>
	<section class="view-onboarding-location" id="view-onboarding-location">
		<section class="graphic">
			<slot name="graphic:before"></slot>
			<!-- <img src="@/Asset/image/onboarding/onboarding-graphic-01.avif" alt="Onboarding Graphic" /> -->
			<video autoplay muted loop playsinline>
				<source src="@/Asset/video/onboarding-location.webm" type="video/webm" />
				<source src="@/Asset/video/onboarding-location.mp4" type="video/mp4" />
			</video>
			<slot name="graphic:after"></slot>
		</section>

		<section class="content">
			<h2 class="title">Find a place to play</h2>

			<p class="large description">
				Our gallery of over 9,000 tables
				<br />
				makes it easy to find the best spot
			</p>
		</section>

		<section class="actions" v-if="isProcessing">
			<img
				alt="Loading"
				class="animate-spin filter-invert"
				height="32"
				src="~@chalkysticks/sass/build/asset/image/icon/loading.svg"
				width="32"
			/>
		</section>

		<section class="actions" v-else>
			<!-- <ViewButtonSkip v-on:skip="$emit('continue')" /> -->
			<button class="button-primary size-medium" v-on:click="Handle_OnClickContinue">Allow Location</button>
		</section>
	</section>
</template>

<script lang="ts">
	import * as Service from '@/App/Service';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted, toggleProperty } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Onboarding
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewOnboardingLocation extends ViewBase {
		/**
		 * @type boolean
		 */
		protected isProcessing: boolean = false;

		/**
		 * @type boolean
		 */
		protected hasProcessed: boolean = false;

		/**
		 * @type Promise<void>
		 */
		@toggleProperty('isProcessing')
		protected async requestLocation(): Promise<void> {
			// Wait for permissions
			const location = await ChalkySticks.Utility.Geolocation.requestLocation();

			// Setup the settings
			this.$store.dispatch('settings/enableLocation', location === 'granted');
			this.$store.commit('settings/setLocationDenied', location === 'denied');

			// If location was granted, start the service
			if (location === 'granted') {
				Service.Location.start();
			}

			// Log the response
			ChalkySticks.Utility.Log.debug('location', 'Permission response:', location);
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnClickContinue(): Promise<void> {
			let delayedComplete: boolean = false;

			// Auto advance so we don't get hung up
			let timeout = setTimeout(() => {
				if (this.hasProcessed) {
					return;
				}

				this.$emit('continue');
				delayedComplete = true;
			}, 1000 * 8);

			// Attempt to get location
			await this.requestLocation();

			// Mark processed
			this.hasProcessed = true;

			// Clear the timeout
			clearTimeout(timeout);

			// Emit continue event to move to next step
			!delayedComplete && this.$emit('continue');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-onboarding-location {
		background-image: url('@/Asset/image/onboarding/onboarding-background-01.avif');
	}
</style>
